import { createSelector } from '@ngrx/store';
import { getMultipleOrderModalState } from '../reducers';
import { selectActiveProductTypeEntity } from './product-type.selector';

export const selectShipmentLocationState = createSelector(getMultipleOrderModalState, state => state && state.shipmentLocation);
export const selectShipmentLocation = createSelector(selectShipmentLocationState, (state) => state && state.payload);

export const selectActiveShipmentLocationId = createSelector(
  selectShipmentLocation,
  (state) => state && state.activeEntityId,
);

export const selectJobsitesStatus = createSelector(
  selectShipmentLocationState,
  ({ isFetched, isLoading, hasError }) => ({
    isFetched,
    isLoading,
    hasError,
  }),
);

export const selectActiveShipmentLocationEntity = createSelector(
  selectActiveShipmentLocationId,
  selectShipmentLocation,
  (shipmentLocationId, state) => {
    return state && state.entities[shipmentLocationId];
  },
);

export const selectAllShipmentLocationIds = createSelector(selectShipmentLocation, ({ ids }) => ids);

export const selectAllShipmentLocations = createSelector(
  selectAllShipmentLocationIds,
  selectShipmentLocation,
  (ids, { entities }) => {
    // @TODO Its showing some kind of weird error, Im not able to to solve this right now
    const _ids: any[] = ids;
    const _entities = entities;
    return _ids.map(id => _entities[id]);
  },
);

export const getFetchedShipmentLocations = createSelector(
  selectJobsitesStatus,
  selectAllShipmentLocations,
  (status, shipmentLocations) => {
    if (status.isFetched) {
      return shipmentLocations;
    }
    return undefined;
  },
);

export const selectActiveShipmentLocationAndProductType = createSelector(
  selectActiveShipmentLocationEntity,
  selectActiveProductTypeEntity,
  (activeShipmentLocation, activeProductType) => ({ activeShipmentLocation, activeProductType }),
);
